import { Text, TextProps } from "@chakra-ui/react";
import _ from "lodash";
import React from "react";

type Props = {
  text: string;
  keyword: string;
  invert?: boolean;
  highlightProps?: TextProps;
};

export const HighlightedText: React.FC<Props> = ({
  text,
  keyword,
  invert = false,
  highlightProps,
}) => {
  const escapedKeyword = _.escapeRegExp(keyword);
  const regex = new RegExp(`(${escapedKeyword})`, "gi");
  const parts = text.split(regex);
  if (keyword.trim() === "") {
    return text;
  }

  const highlighted = parts.map((part, i) => {
    const isKeyword = part.toLowerCase() === keyword.toLowerCase();
    const shouldHighlight = invert ? !isKeyword : isKeyword;

    if (shouldHighlight && part.trim().length > 0) {
      return (
        <Text as="b" key={i} {...highlightProps}>
          {part}
        </Text>
      );
    } else {
      return <React.Fragment key={i}>{part}</React.Fragment>;
    }
  });
  return <>{highlighted}</>;
};
